export default {
  fontColor: 'var(--white)',
  h2Align: 'left',
  h2Margin: '5rem',
};
